import React from 'react';
import './DashboardAside.css';
import connectionLine from '../../assets/conection.svg';
import DailyTimeline from './calendar/DailyTimeline';
import TimeDifferenceWidget from './TimeDifferenceWidget';

const DashboardAside = ({ userAvatar, userName, userCity, partnerInfo, navigateToProfile }) => {
    return (
        <aside className="dashboard-aside">
            <div className="aside-user">
                {userAvatar && (
                    <img
                        src={userAvatar}
                        alt="User Avatar"
                        className="header-user-avatar-aside"
                        onClick={navigateToProfile}

                    />
                )}
                <div className="aside-username" onClick={navigateToProfile}>{userName}</div>
            </div>

            {partnerInfo && partnerInfo.city && (
                <div className="aside-connection">
                    <div className="aside-city">{userCity}</div>
                    <img src={connectionLine} alt="Connection" className="aside-connection-line" />
                    <div className="aside-city">{partnerInfo.city}</div>
                </div>
            )}

            <div className="aside-time-difference">
                <TimeDifferenceWidget />
            </div>

            <div className="aside-daily-timeline-wrapper">
                <DailyTimeline />
            </div>

        </aside>
    );
};

export default DashboardAside;
